import createSagaMiddleware from 'redux-saga';
import { createStore, applyMiddleware, Store } from 'redux';
import { useSelector as defaultUseSelector } from 'react-redux';

import rootReducer from './ducks/rootReducer';
import rootSaga from './ducks/rootSagas';

export type ApplicationState = ReturnType<typeof rootReducer>;

export const useSelector = () =>
  defaultUseSelector((state: ApplicationState) => state);

const sagaMiddleware = createSagaMiddleware();

const storeMiddlewares = applyMiddleware(sagaMiddleware);

const store: Store<ApplicationState> = createStore(
  rootReducer,
  storeMiddlewares
);

sagaMiddleware.run(rootSaga);

export default store;
